module.exports = __webpack_public_path__ + "resources/icon_yello_p.42a6dc6a55f68d8f.png";